import { BrandedFooter } from '@components/branding';
import CompoundTranslation from '@components/compound-translation';
import FormI9CandidateDetails from '@containers/form-i9/candidate-details';
import FormI9Header from '@containers/form-i9/form-header';
import FormI9PreparerTranslatorCertification from '@containers/form-i9/preparer-translator-certification';
import USCISFormI9Section2Link from '@containers/links/uscis-formI9-section2-link';
import USCISWebsiteLink from '@containers/links/uscis-website-link';
import { ISection1CandidateDetail } from '@models/onboarding-review/section1-candidate-detail';
import { ISection1PreparerTranslator } from '@models/onboarding-review/section1-preparer-translator';
import { FormI9Container } from '@screens/review-section2/employee-information/styles';
import {
    Buttons,
    DashedDivider,
    FocusedError
} from '@screens/review-section2/styles';
import {
    InstructionLine,
    Title
} from '@screens/review-section3/review/styles';
import {
    CenterContainer,
    Content,
    Header
} from '@screens/review-section3/styles';
import { createTranslationService, createConfigurationValuesService } from '@services/factories';
import { authenticationParamsContext } from '@stores/authentication/authentication-params-context';
import { ISection2ReviewStore } from '@stores/onboarding-review/section2-review-store';
import { ScrollContainer } from '@styles/container-styles';
import {
    ConfirmRowButton,
    RejectRowButton
} from '@styles/shared-styles';
import { VerticalLayout } from '@styles/spacing-styles';
import { cacheTranslations } from '@utils/cache-translations';
import { observer } from 'mobx-react';
import * as React from 'react';
import { IConfigurationValuesService } from '@services/ConfigurationValuesService';
import { ISection2DocumentsStore } from '@stores/onboarding-review/section2-documents-store';
import { LoaderBox, LoaderContainer } from '@components/loader/styles';
import { Spinner } from '@blueprintjs/core';
import { isNil } from 'lodash';

interface IProps {
    reviewStore: ISection2ReviewStore;
    candidateDetails: ISection1CandidateDetail;
    preparerTranslator: ISection1PreparerTranslator;
    documentDetails: ISection2DocumentsStore;
    onConfirm?: () => void;
    onDecline?: () => void;
}

enum FormI9EmployeeInformationTranslation {
    instructionForCandidateTemplate = 'instructionForCandidateTemplate',
    stepInstruction = 'stepInstruction',
    uscisDescription = 'uscisDescription',
    section2Description = 'section2Description',
    confirmButton = 'confirmButton',
    confirmClickAgreement = 'confirmClickAgreement',
    loadDetailsError = 'loadDetailsError',
    declineButton = 'declineButton'
}

class FormI9EmployeeInformation extends React.Component<IProps> {
    readonly translations = cacheTranslations(
        createTranslationService(),
        FormI9EmployeeInformationTranslation,
        'section2Step4'
    );
    readonly configurationValuesService: IConfigurationValuesService = createConfigurationValuesService();
    handleConfirm = () => {
        this.props.onConfirm?.();
    };

    handleDecline = () => this.props.onDecline?.();

    render() {
        const {
            reviewStore,
            candidateDetails,
            preparerTranslator,
            documentDetails: section2DocumentDetails
        } = this.props;

        if (
            !this.configurationValuesService.showSection1 ||
            (!isNil(section2DocumentDetails.applicantStatus) &&
                section2DocumentDetails.applicantStatus !== '')
        ) {
            this.handleConfirm();
        }
        
        if(section2DocumentDetails.loadingApplicantStatus) {
            return (
                <LoaderContainer>
                  <LoaderBox className='spinner'>
                    <Spinner size={30} />
                  </LoaderBox>
                </LoaderContainer>
              );
        }

        return (
            <ScrollContainer>
                <CenterContainer fillAvailable={true}
                                 constrainToParentWidth={true}>
                    <FormI9Container>
                        <Header>
                            <authenticationParamsContext.Consumer>
                                {
                                    params => <CompoundTranslation template={this.translations.instructionForCandidateTemplate}
                                                                   data={[params?.fullName]}/>
                                }
                            </authenticationParamsContext.Consumer>
                            <Title topSpacing={true}
                                   bottomSpacing={true}>
                                {this.translations.stepInstruction}
                            </Title>
                            <InstructionLine>{this.translations.uscisDescription} <USCISWebsiteLink/></InstructionLine>
                            <InstructionLine>{this.translations.section2Description} <USCISFormI9Section2Link/></InstructionLine>
                        </Header>
                        <Content>
                            <VerticalLayout innerSpacing={'large'}
                                            bottomSpacing={'large'}>
                                {
                                    reviewStore.loadDetailsRequestStatus === 'error' && (
                                        <FocusedError>{this.translations.loadDetailsError}</FocusedError>
                                    )
                                }
                                <div>
                                    <FormI9Header/>
                                    <VerticalLayout innerSpacing={'small'}>
                                        <FormI9CandidateDetails fields={candidateDetails}/>
                                        <FormI9PreparerTranslatorCertification fields={preparerTranslator}/>
                                    </VerticalLayout>
                                </div>
                                <div>
                                    <DashedDivider/>
                                    <Buttons innerSpacing={'small'}>
                                        <RejectRowButton onClick={this.handleDecline}>
                                            {this.translations.declineButton}
                                        </RejectRowButton>
                                        <ConfirmRowButton onClick={this.handleConfirm}>
                                            {this.translations.confirmButton}
                                        </ConfirmRowButton>
                                    </Buttons>
                                    <i>{this.translations.confirmClickAgreement}</i>
                                </div>
                            </VerticalLayout>
                        </Content>
                    </FormI9Container>
                </CenterContainer>
                <BrandedFooter />
            </ScrollContainer>
        );
                            }
    }

export default observer(FormI9EmployeeInformation);



// WEBPACK FOOTER //
// ./src/screens/review-section2/employee-information/page.tsx